import { getReferenceRoute } from "src/utils";

interface IJournalEntryRouteSource {
  source?: string | null;
  source_type?: string | null;
  source_id?: number | null;
  parent_source_type?: string | null;
  parent_source_id?: number | null;
  related_reference?: string | null;
}

// Resolves the detail-page route for a general ledger entry, falling back to the index list.
export const getJournalEntryRoute = (row: IJournalEntryRouteSource): string => {
  // Prefer parent document id (e.g. purchase behind a payment) over line-level source.
  const idForOrigin = (origin: string): number | null => {
    if (row.parent_source_type === origin && row.parent_source_id) {
      return row.parent_source_id;
    }
    if (row.source_type === origin && row.source_id) {
      return row.source_id;
    }
    return null;
  };

  const purchaseId = idForOrigin("purchase");
  if (purchaseId) return `/purchasing/${purchaseId}`;

  const invoiceId = idForOrigin("invoice");
  if (invoiceId) {
    return row.source === "fixed_assets"
      ? `/assets/transaction/${invoiceId}`
      : `/operation/transaction/${invoiceId}`;
  }

  const transferId = idForOrigin("transfer");
  if (transferId) return `/transfer/transaction/${transferId}`;

  return getReferenceRoute(row.related_reference ?? "");
};
